/**
 * 观看限制
 * Create by liaokai on 2020-05-23 17:59:31
 */
import * as React from 'react';
import {Component} from "react";
import {Button, message, Tabs} from "antd";
import {LiveLimitFee} from "./fee/fee";
import {LiveLimitFree} from "./free/free";
import {LiveLimitInvite} from "./Invite/Invite";
import { LiveLimitPwd } from "./pwd/pwd";
import { LiveLimitWhite } from './white-list/white-list';
import styled from "styled-components";
import {liveLookSet} from "../../../../../../common/apis/apis/live/liveLookSet";
import {liveLook} from "../../../../../../common/apis/apis/live/liveLook";
import {liveStore} from "../live.store";

const { TabPane } = Tabs;

interface IProps{

}

interface IState{
    data : any
}

export class LiveLimitView extends Component<IProps,IState>{
    readonly state : IState = {
        data : undefined
    };

    componentDidMount() {
        liveLook({
            live_id : liveStore.live_id
        }).then(res => {
            this.setState({data : res})
            console.log(this.state.data)
        })
    }

    render() {
        let {} = this.props;
        let {data} = this.state;
        return (
            <div>
                <Tabs activeKey={data?.type?.toString?.() ?? undefined} onTabClick={(activeKey : string) =>{
                    //@ts-ignore
                    this.setState({data : {
                        ...data,
                        type : activeKey
                    }})
                }} destroyInactiveTabPane={true} defaultActiveKey="1" type="card" style={{ marginBottom: 32 }}>
                    <TabPane tab="免费" key="1">
                        <Padding>
                            <LiveLimitFree data={data} onChange={data => this.setState({data})}/>
                        </Padding>
                    </TabPane>
                    {/* <TabPane tab="付费" key="2">
                        <Padding>
                            <LiveLimitFee data={data} onChange={data => this.setState({data})}/>
                        </Padding>
                    </TabPane>
                    <TabPane tab="邀请码" key="3">
                        <Padding>
                            <LiveLimitInvite data={data} onChange={data => this.setState({data})}/>
                        </Padding>
                    </TabPane> */}
                    <TabPane tab="密码" key="4">
                        <Padding>
                            <LiveLimitPwd data={data} onChange={data => this.setState({data})}/>
                        </Padding>
                    </TabPane>
                    {/* <TabPane tab="白名单" key="5">
                        <Padding>
                            <LiveLimitWhite data={data} onChange={data => this.setState({data})}/>
                        </Padding>
                    </TabPane> */}
                </Tabs>
                <Button type={"primary"} onClick={()=>{
                    liveLookSet({...this.state.data, live_id : liveStore.live_id}).then(res => {
                        message.success("保存成功")
                    }).catch(e => {
                        message.error("保存失败 "+ e.data?.message)
                    }).finally(()=>{
                        liveStore.reload();
                    })
                    if(this.state.data?.type != 4){
                        this.state.data.password = ""
                        this.setState({data : data})
                    }
                }}>保存</Button>
            </div>
        );
    }
}

const Padding = styled.div`
  padding: 10px;
`
